export const exportTransactions = async (searchParams, apiConfig) => {
    const { apiRoot, apiHeaders } = apiConfig;
    const {
        selectedProduct,
        selectedStore,
        selectedMerchantProfile,
        startDate,
        endDate,
        startTime,
        endTime,
        transactionId,
        invoiceId,
        createSearchPayload
    } = searchParams;

    let allTransactions = [];
    let currentPage = 0;
    let totalPages = 1;

    // Fetch all pages of transactions
    while (currentPage < totalPages) {
        const searchPayload = createSearchPayload(
            selectedProduct,
            selectedStore,
            selectedMerchantProfile,
            startDate,
            endDate,
            startTime,
            endTime,
            transactionId,
            invoiceId,
            currentPage
        );

        searchPayload.size = 100; // Adjust page size as needed

        const response = await fetch(
            `${apiRoot}/backoffice/transactions/search`, {
                method: 'POST',
                headers: apiHeaders,
                body: JSON.stringify(searchPayload)
            }
        );

        if (!response.ok) {
            throw new Error('Failed to fetch transactions for export');
        }

        const data = await response.json();
        allTransactions = allTransactions.concat(data.content);
        totalPages = data.totalPages;
        currentPage++;
    }

    // Convert to CSV
    const csv = convertTransactionsToCSV(allTransactions);

    // Create and download file
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', `transactions_${new Date().toISOString().split('T')[0]}.csv`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

const convertTransactionsToCSV = (transactions) => {
    if (!transactions || transactions.length === 0) {
        return 'No transactions found';
    }

    const headers = [
        'Idempotency Key',
        'Amount',
        'Currency',
        'Checkout Session ID',
        'Store ID',
        'Merchant Profile ID',
        'Payment Method',
        'Payment Provider',
        'Invoice ID',
        'Created At',
        'Updated At',
        'Status',
        'Type',
        'PSP Reference',
        'Payment Reference',
        'Error Code'
    ];

    const rows = transactions.map(transaction => [
        transaction.idempotencyKey || '',
        transaction.amount?.value || '',
        transaction.amount?.currency || '',
        transaction.checkoutSessionId || '',
        transaction.storeId || '',
        transaction.merchantProfileId || '',
        transaction.paymentMethodName || '',
        transaction.paymentProviderName || '',
        transaction.invoiceId || '',
        transaction.createdAt || '',
        transaction.updatedAt || '',
        transaction.status || '',
        transaction.type || '',
        transaction.pspReference || '',
        transaction.paymentReference || '',
        transaction.errorCode || ''
    ]);

    const csvContent = [headers, ...rows]
        .map(row => row.map(field => `"${field}"`).join(','))
        .join('\n');

    return csvContent;
};